import {Component, Injector} from '@angular/core';
import {Observable} from "rxjs";
import {NotificationsService} from "../../../../services/notifications.service";
import {NotificationViewModel} from "../Model/NotificationViewModel";
import {CreateNotificationComponent} from "../create-notification.component";
import {EditNotificationComponent} from "../edit-notification.component";
import { IManagableObject } from "../../IManagableObject";
import { GroupBaseAdminPanelComponent } from '../../base-admin-panel/group-base-admin-panel.component';

@Component({
    selector: '[app-notifications]',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.css'],
    standalone: false
})
export class NotificationsComponent extends GroupBaseAdminPanelComponent {
  public term: string;
  private service: NotificationsService;

  constructor(protected injector: Injector) {
    super(injector);
    this.service = injector.get(NotificationsService);
  }

  protected Refresh() {
    this.service.GetNotifications()
      .subscribe((notifications) => {
        this.objects = notifications;
      });
    this.service.GetGroups().subscribe(groups => {
      this.groupFilter.groups = groups;
    });
  }

  protected doDeleteObject(id: number): Observable<any> {
    return this.service.delete(id);
  }

  public openEditModal(command: NotificationViewModel) {
    this.prepareModal(EditNotificationComponent);
    this.componentRef.instance.open(command);
  }

  public openCreateModal() {
    this.prepareModal(CreateNotificationComponent);
    this.componentRef.instance.open(new NotificationViewModel());
  }
  public createDublicate(object: NotificationViewModel)
  {
    var clone = Object.assign({}, object);
    clone.Name = "";
    clone.Id = 0;
    this.openEditModal(clone);
  }

  protected doCreateGroup(input: IManagableObject): Observable<any> {
    return this.service.CreateGroup(input);
  }

  protected doDeleteGroup(input: IManagableObject): Observable<any> {
    return this.service.DeleteGroup(input);
  }
}
